export function stripHTML(string) {
  if (!string) {
    return '';
  }
  if (typeof document !== undefined) {
    try {
      var div = document.createElement('div');
      div.innerHTML = string;
      return div.textContent || div.innerText || '';
    } catch (err) {
      return '';
    }
  }
}
